import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sh-dialog-body',
  templateUrl: './dialog-body.component.html',
  styleUrls: ['./dialog-body.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogBodyComponent {
}
